import { STOModel } from "../../models/base/sto-model";
import { TnAAbsenceDTO } from "../../models/tna";
import { BaseApiService } from "../base/base-api.service";

export class EmployeeOverlappingAbsencesApiService extends BaseApiService<TnAAbsenceDTO, STOModel> {
  constructor() {
    super({
      servicePath: "/TnAAbsences",
      loadItemsPath: "/GetEmployeeOverlappingAbsences",
    });
  }
}
